import React from "react";
import Button from "@material-ui/core/Button/Button";
import { Link } from "react-router-dom";

import NavbarLayout from "components/styled/layouts/navbarLayout/NavbarLayout";
import ContentSectionMaxWidth from "components/styled/contentSection/ContentSectionMaxWidth";
import {
  ButtonGroup,
  ButtonGroupLabel,
} from "components/styled/toolboxButtons/ButtonGroup";
import liquidacionIcon from "assets/icons/ic_liquidacion_color.svg";
import analisisIcon from "assets/icons/ic_analisis_color.svg";
import confeccionIcon from "assets/icons/ic_confeccion_color.svg";
import { useTokenPermission } from "components/hooks/usePermissionsFromToken";

const Home = () => {
  return (
    <NavbarLayout>
      <ContentSectionMaxWidth>
        <ButtonGroup marginBottom={35}>
          {useTokenPermission("analisis:verListado") && (
            <Button component={Link} to="/analisis">
              <ButtonGroupLabel
                label={"Análisis"}
                subLabel={"crédito"}
                icon={analisisIcon}
              />
            </Button>
          )}
          {useTokenPermission("confeccion:verListado") && (
            <Button component={Link} to="/confeccion">
              <ButtonGroupLabel
                label={"Confección"}
                subLabel={"prenda"}
                icon={confeccionIcon}
              />
            </Button>
          )}
          {useTokenPermission("liquidacion:verListado") && (
            <Button component={Link} to="/liquidacion">
              <ButtonGroupLabel
                label={"Liquidación"}
                subLabel={"crédito"}
                icon={liquidacionIcon}
              />
            </Button>
          )}
        </ButtonGroup>
      </ContentSectionMaxWidth>
    </NavbarLayout>
  );
};

export default Home;
